var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"mb-0",attrs:{"title":"Total de clientes","type":"success","sub-title":`${_vm.value}`,"icon":"ni ni-single-02"}})
}
var staticRenderFns = []

export { render, staticRenderFns }